import { render, staticRenderFns } from "./echart.vue?vue&type=template&id=8f1cb86a&scoped=true&"
import script from "./echart.vue?vue&type=script&lang=js&"
export * from "./echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1cb86a",
  null
  
)

export default component.exports